import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  ButtonGroup,
  Collapse,
  CardDeck,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import moment from "moment";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, } from "../helpers";
import "react-datepicker/dist/react-datepicker.css";

const resolveList = (list, hasMaintenanceRecord) => {
  let newList = [];
  if(hasMaintenanceRecord) {
     newList = _.filter(list, item => {
      return item.maintenanceRecordId !== null;
    })
  } else {
    newList =  _.filter(list, item => {
      return item.maintenanceRecordId === null;
    });
  }
  return newList;
}
export default class EquipmentDamages extends Component {
  static displayName = EquipmentDamages.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      recordsCollapse: false,
      addNew: false,
      description: '',
      resolvedDamageList: props.damageList.length
        ? resolveList(this.props.damageList, true)
        : [],
      unResolvedDamagesList: props.damageList.length
        ? resolveList(this.props.damageList, false)
        : []
    };
  }

  toggleCollapse() {
    this.setState({
      recordsCollapse: !this.state.recordsCollapse
    });
  }

  onInputChange(e) {
    this.setState({
      description:  e.target.value 
    })
  }

  onAddNew() {
    this.setState({addNew: !this.state.addNew})
  }

  onCancel() {
    this.setState({
      description: '',
      addNew: false
    })
  }

  onSave() {
    const payload = {
      Description: this.state.description,
      EquipmentId: this.props.equipmentId
    }
    api.post("Equipment/SaveDamageRecord", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success("Damage Record was saved.")
          this.onCancel();
          this.props.reLoad();
        } else {
          Alert.error("Damage record cannot be saved at this time.")
        }
      }).catch(x => {
        Alert.error("An unexpected error occured.")
        console.error(x)
      });
  }
  render() {
    const {
      addNew,
      resolvedDamageList,
      unResolvedDamagesList
    }
      = this.state;
    return (
      <Card className="p-2 mb-2">
        <CardHeader className="boldText">
          <span className="mr-2"><FontAwesomeIcon icon={"house-damage"} className="" title={`Damages`} /></span>
          Damage History
          <Button size="sm" className="float-right cbdmdSuccess" onClick={() => this.toggleCollapse()}>{this.state.recordsCollapse ? "View Less" : "View More"}</Button>
        </CardHeader>
        <Collapse isOpen={this.state.recordsCollapse}>
          <CardBody>
            <Row>
              <Col>
                {addNew &&
                  <Fragment>
                    Damage Description:
                    <div>
                    <Input
                      type="textarea"
                      maxLength="60"
                      name="description"
                      id="description"
                      onChange={(e) => this.onInputChange(e)} />
                    </div>
                  </Fragment>
                }
              </Col>
              <Col xs="2">
              <ButtonGroup className="float-right">
                  {addNew ? (
                    <Fragment>
                      <Button size="sm" color="secondary" className="float-right buttonGroupSpacing" title="Cancel" onClick={() => this.onCancel()}>
                        <FontAwesomeIcon icon="reply" />
                      </Button>
                      <Button size="sm" className="float-right buttonGroupSpacing cbdmdPrimary" title="Save" onClick={() => this.onSave()}>
                        <FontAwesomeIcon icon="save" />
                      </Button>
                    </Fragment>
                  ) : (
                    <Button size = "sm" color = "success" className ="float-right buttonGroupSpacing" title="Report a damage" onClick={() => this.onAddNew()}>
                      <FontAwesomeIcon icon="plus" /> Report Damage
                    </Button>
                )}
                </ButtonGroup>
              </Col>
            </Row>
            {this.props.damageList && this.props.damageList.length > 0 ? (
              <CardDeck className="mt-2">
                <Card>
                  <CardHeader>Unresolved</CardHeader>
                  <CardBody>
                    <ListGroup>
                      {unResolvedDamagesList && unResolvedDamagesList.length > 0 ?
                        unResolvedDamagesList.map((damage, index) => (
                          <ListGroupItem key={`dam-${index}${damage.id}`}>
                          <Row>
                              <Col xs="1" className="cbdmdDangerText centerText "><FontAwesomeIcon icon="exclamation-triangle" size="2x"/></Col>
                              <Col>
                                <div className="ml-2" >{damage.description}</div>
                                <div className="ml-2 detailTextNoSize">Reported by: {damage.enteredByUserName} on {moment(damage.createdAt).format("M/DD/YYYY")}</div>
                              </Col>
                              </Row>
                        </ListGroupItem>
                        )) : <ListGroupItem><span className="detailText">No Unresolved Damages</span></ListGroupItem>}
                    </ListGroup>
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader>Resolved</CardHeader>
                  <CardBody>
                    <ListGroup>
                      {resolvedDamageList && resolvedDamageList.length > 0 ?
                        resolvedDamageList.map((damage, index) => (
                          <ListGroupItem key={`dam-${index}${damage.id}`}>
                          <Row>
                              <Col xs="1" className="successText centerText "><FontAwesomeIcon icon="check-circle" /></Col>
                              <Col className="ml-2" >{damage.description}</Col>
                              {/*<div className="ml-2">Reported by: {damage.enteredByUserName} on {moment(damage.createdAt).format("M/DD/YYYY")}</div>*/}
                            </Row>
                          </ListGroupItem>
                        )) : <ListGroupItem><span className="detailText">No Resolved Damages</span></ListGroupItem>}
                    </ListGroup>
                  </CardBody>
                </Card>
              </CardDeck>

            ) : <div className="detailText">No Reported Damages Found</div>}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentDamages.js